import cn from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CymbioSpinner } from '../../common/Spinner';
import Select from '../../common/Select';
import { tiktokListWarehouses, tiktokPostWarehouseId } from '../../../store/actions/channels';

import styles from './TikTokWarehouseSelect.module.scss';
import { CHANNELS } from '../../../constants/channels';

export function TikTokWarehouseSelect(props) {
  const { supplierId, retailerId } = props;
  const dispatch = useDispatch();

  const {
    data: {
      [CHANNELS.TIKTOK]: { warehouses },
    },
    loading: { listWarehouses: loadingWarehouses, postWarehouse: loadingPostWarehouse },
  } = useSelector((state) => state.channels);

  const options = useMemo(() => {
    if (!warehouses?.length) return [];

    const options = warehouses.map((warehouse) => ({
      label: warehouse.name,
      value: warehouse.id,
    }));
    return options;
  }, [warehouses]);

  const [selected, setSelected] = useState(options[0]?.value);

  useEffect(
    function listWarehouses() {
      dispatch(tiktokListWarehouses({ supplierId, retailerId }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [supplierId, retailerId],
  );

  useEffect(
    function setSelectedWarehouse() {
      if (warehouses?.length) {
        setSelected(warehouses[0].id);
      }
    },
    [warehouses],
  );

  const onContinue = () => {
    dispatch(tiktokPostWarehouseId({ supplierId, retailerId, selected }));
  };

  const onRefresh = () => {
    dispatch(tiktokListWarehouses({ supplierId, retailerId }));
  };

  if (loadingWarehouses) {
    return (
      <div className={styles.wrapper}>
        <h3>Getting warehouses from TikTok...</h3>
        <CymbioSpinner />
      </div>
    );
  }

  if (warehouses.length === 0) {
    return (
      <div className={cn(styles.wrapper, styles.noWarehouses)}>
        <h3>
          Our system has not detected any <strong>active sales warehouse</strong> on TTS,
          <br />
          <a
            href="https://seller-us.tiktok.com/university/essay?anchor_link=EB1800D5&course_type=1&from=search&identity=1&is_new_connect=0&is_new_user=0&knowledge_id=2243928760354606&role=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            please create and enable a sales warehouse
          </a>{' '}
          and try again.
        </h3>

        <div className={styles.actions}>
          <button onClick={onRefresh}>Refresh</button>
          <button disabled>Continue</button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <h3>Please choose which warehouse you want to connect:</h3>
      <div className={styles.selectWrapper}>
        <Select options={options} onChange={setSelected} value={selected} />
        <button onClick={onContinue} disabled={loadingPostWarehouse || !selected}>
          Continue
        </button>
      </div>
    </div>
  );
}

TikTokWarehouseSelect.propTypes = {
  supplierId: PropTypes.number.isRequired,
  retailerId: PropTypes.number.isRequired,
};
